import React, {useMemo, useRef, useState} from "react";
import {useQuery} from "@tanstack/react-query";
import {AgGridReact} from "ag-grid-react";
import {FaEraser, FaPlus, FaSearch} from "react-icons/fa";
import {Template} from "../../../components/template/template.jsx";
import {Card} from "../../../components/card/card.jsx";
import Button from "../../../components/button/button.jsx";
import InputForm from "../../../components/input/input-form.jsx";
import AbsenceTypeService from "../../../services/web/absence-type-service.js";
import aggridUtils from "../../../utils/aggrid-utils.js";
import {navigateHook} from "../../../hooks/use-navigate.js";

const AbsenceTypesList = () => {
    const navigate = navigateHook();
    const gridRef = useRef();
    const [filter, setFilter] = useState("");
    const {data = [], isLoading} = useQuery({
        queryKey: ["absence-types"],
        queryFn: AbsenceTypeService.list,
        staleTime: 0,
        gcTime: 0,
        refetchOnMount: "always"
    });
    const columns = useMemo(() => [{field: "name", headerName: "Nome", flex: 1, comparator: aggridUtils.nullLastComparator}], []);
    const search = () => gridRef.current?.api.setGridOption("quickFilterText", filter);
    const clear = () => { setFilter(""); gridRef.current?.api.setGridOption("quickFilterText", ""); };
    return <Template isLoading={isLoading}>
        <Template.Header>
            <Template.Title>Motivos de ausência</Template.Title>
            <Button onClick={() => navigate("/absence-types/form", false)}>
                <FaPlus/> Adicionar motivo
            </Button>
        </Template.Header>
        <Template.Body className="flex flex-col space-y-2">
            <Card>
                <Card.Body>
                    <div className="flex items-end gap-4">
                        <div className="flex-1">
                            <InputForm id="name" label="Nome" value={filter} onChange={({target}) => setFilter(target.value)} onKeyDown={({key}) => key === "Enter" && search()}/>
                        </div>
                        <div className="flex gap-2">
                            <Button target="primary-outline" title="Limpar" onClick={clear}>
                                <FaEraser/>
                            </Button>
                            <Button title="Buscar" onClick={search}>
                                <FaSearch/>
                            </Button>
                        </div>
                    </div>
                </Card.Body>
            </Card>
            <Card>
                <Card.Body>
                    <div className="h-[calc(100vh-153px)] aggrid-row-pointer">
                        <AgGridReact ref={gridRef}
                                     rowData={data}
                                     columnDefs={columns}
                                     pagination
                                     paginationPageSize={100}
                                     paginationPageSizeSelector={[20, 50, 100, 500]}
                                     animateRows={false}
                                     suppressCellFocus gridOptions={{localeText: aggridUtils.localization()}}
                                     theme={aggridUtils.generalTheme()}
                                     onRowClicked={({data: row}) => navigate(`/absence-types/form/${row.id}`, false)}/>
                    </div>
                </Card.Body>
            </Card>
        </Template.Body>
    </Template>;
};
export default AbsenceTypesList;
